/**
 * Tableaux de paramétrage DGI (SFE §2.35, annexe §7) — runtime shape.
 *
 * The four annex tables are exposed as rows a tenant can extend at runtime.
 * The DGI constants (CLIENT_TYPES, ARTICLE_TYPES, CREDIT_NOTE_TYPES,
 * COMMENT_LINE_TYPES) are the floor: a resolved table always contains them,
 * and tenant rows only add codes or fill fields the annex leaves blank.
 */
/** The four annex tables, keyed exactly as stored in TenantParameterRow.table. */
export const PARAMETER_TABLE_NAMES = [
    "CLIENT_TYPE",
    "ARTICLE_TYPE",
    "CREDIT_NOTE_TYPE",
    "COMMENT_LINE",
];
/** French titles of the four tables, as printed in the annex. */
export const PARAMETER_TABLE_LABELS = {
    CLIENT_TYPE: "Types du client",
    ARTICLE_TYPE: "Types d'article",
    CREDIT_NOTE_TYPE: "Nature de facture d'avoir",
    COMMENT_LINE: "Lignes de commentaires",
};
/** Text columns of a row that a tenant may complete (never overwrite). */
export const PARAMETER_ROW_FIELDS = [
    "label",
    "invoiceMention",
    "description",
    "applicableCase",
];
/** French names of the text columns, used in error messages. */
export const PARAMETER_ROW_FIELD_LABELS = {
    label: "libellé",
    invoiceMention: "mention sur la facture",
    description: "description",
    applicableCase: "applicable dans le cas",
};
/**
 * Columns each table carries, mirroring the annex: the client, article and
 * credit-note tables have a mention column; comment lines have an
 * « applicable dans le cas » column instead.
 */
export const PARAMETER_TABLE_COLUMNS = {
    CLIENT_TYPE: ["label", "invoiceMention", "description"],
    ARTICLE_TYPE: ["label", "invoiceMention", "description"],
    CREDIT_NOTE_TYPE: ["label", "invoiceMention", "description"],
    COMMENT_LINE: ["label", "description", "applicableCase"],
};
//# sourceMappingURL=types.js.map